export const assetMap = {
  "icons": {
    "icon-account-linking-failed.svg": {
      "name": "icon-account-linking-failed",
      "hashedName": "icon-account-linking-failed.994795b63437",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-account-linking-failed.svg",
        "hashedPath": "icons/suffixed/icon-account-linking-failed.994795b63437.svg"
      }
    },
    "icon-arrow-down.svg": {
      "name": "icon-arrow-down",
      "hashedName": "icon-arrow-down.bbaae3aa38cd",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-down.svg",
        "hashedPath": "icons/suffixed/icon-arrow-down.bbaae3aa38cd.svg"
      }
    },
    "icon-arrow-right.svg": {
      "name": "icon-arrow-right",
      "hashedName": "icon-arrow-right.f11a09b9faf3",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-right.svg",
        "hashedPath": "icons/suffixed/icon-arrow-right.f11a09b9faf3.svg"
      }
    },
    "icon-back.svg": {
      "name": "icon-back",
      "hashedName": "icon-back.100a137cc3a1",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-back.svg",
        "hashedPath": "icons/suffixed/icon-back.100a137cc3a1.svg"
      }
    },
    "icon-change.svg": {
      "name": "icon-change",
      "hashedName": "icon-change.caea84b7aa36",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-change.svg",
        "hashedPath": "icons/suffixed/icon-change.caea84b7aa36.svg"
      }
    },
    "icon-chevron-down-white.svg": {
      "name": "icon-chevron-down-white",
      "hashedName": "icon-chevron-down-white.884b9d6901f0",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-chevron-down-white.svg",
        "hashedPath": "icons/suffixed/icon-chevron-down-white.884b9d6901f0.svg"
      }
    },
    "icon-chevron-down.svg": {
      "name": "icon-chevron-down",
      "hashedName": "icon-chevron-down.3d8c93cfbf85",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-chevron-down.svg",
        "hashedPath": "icons/suffixed/icon-chevron-down.3d8c93cfbf85.svg"
      }
    },
    "icon-chevron-left-hyperlink.svg": {
      "name": "icon-chevron-left-hyperlink",
      "hashedName": "icon-chevron-left-hyperlink.9d6b358a220d",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-chevron-left-hyperlink.svg",
        "hashedPath": "icons/suffixed/icon-chevron-left-hyperlink.9d6b358a220d.svg"
      }
    },
    "icon-chevron-right.svg": {
      "name": "icon-chevron-right",
      "hashedName": "icon-chevron-right.d4dfc14a6543",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-chevron-right.svg",
        "hashedPath": "icons/suffixed/icon-chevron-right.d4dfc14a6543.svg"
      }
    },
    "icon-chevron-up-white.svg": {
      "name": "icon-chevron-up-white",
      "hashedName": "icon-chevron-up-white.0508aca1b5a4",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-chevron-up-white.svg",
        "hashedPath": "icons/suffixed/icon-chevron-up-white.0508aca1b5a4.svg"
      }
    },
    "icon-chevron-up.svg": {
      "name": "icon-chevron-up",
      "hashedName": "icon-chevron-up.37cf6e0a105f",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-chevron-up.svg",
        "hashedPath": "icons/suffixed/icon-chevron-up.37cf6e0a105f.svg"
      }
    },
    "icon-clock.svg": {
      "name": "icon-clock",
      "hashedName": "icon-clock.48c5d1103d5d",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-clock.svg",
        "hashedPath": "icons/suffixed/icon-clock.48c5d1103d5d.svg"
      }
    },
    "icon-close-white.svg": {
      "name": "icon-close-white",
      "hashedName": "icon-close-white.02b1f24a8284",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-close-white.svg",
        "hashedPath": "icons/suffixed/icon-close-white.02b1f24a8284.svg"
      }
    },
    "icon-close.svg": {
      "name": "icon-close",
      "hashedName": "icon-close.9e1e6123c9cb",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-close.svg",
        "hashedPath": "icons/suffixed/icon-close.9e1e6123c9cb.svg"
      }
    },
    "icon-convert-points.svg": {
      "name": "icon-convert-points",
      "hashedName": "icon-convert-points.16afd09d99c8",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-convert-points.svg",
        "hashedPath": "icons/suffixed/icon-convert-points.16afd09d99c8.svg"
      }
    },
    "icon-disclaimer-info.svg": {
      "name": "icon-disclaimer-info",
      "hashedName": "icon-disclaimer-info.3764d88d3a2b",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-disclaimer-info.svg",
        "hashedPath": "icons/suffixed/icon-disclaimer-info.3764d88d3a2b.svg"
      }
    },
    "icon-equal.svg": {
      "name": "icon-equal",
      "hashedName": "icon-equal.aed8bd2755c5",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-equal.svg",
        "hashedPath": "icons/suffixed/icon-equal.aed8bd2755c5.svg"
      }
    },
    "icon-error.svg": {
      "name": "icon-error",
      "hashedName": "icon-error.2539a35bf244",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-error.svg",
        "hashedPath": "icons/suffixed/icon-error.2539a35bf244.svg"
      }
    },
    "icon-error404.svg": {
      "name": "icon-error404",
      "hashedName": "icon-error404.c0bb9c4ce2a2",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-error404.svg",
        "hashedPath": "icons/suffixed/icon-error404.c0bb9c4ce2a2.svg"
      }
    },
    "icon-failed.svg": {
      "name": "icon-failed",
      "hashedName": "icon-failed.994795b63437",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-failed.svg",
        "hashedPath": "icons/suffixed/icon-failed.994795b63437.svg"
      }
    },
    "icon-hamburger-menu.svg": {
      "name": "icon-hamburger-menu",
      "hashedName": "icon-hamburger-menu.a2dd9c74b559",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-hamburger-menu.svg",
        "hashedPath": "icons/suffixed/icon-hamburger-menu.a2dd9c74b559.svg"
      }
    },
    "icon-http-error.svg": {
      "name": "icon-http-error",
      "hashedName": "icon-http-error.6fa7ba4c021c",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-http-error.svg",
        "hashedPath": "icons/suffixed/icon-http-error.6fa7ba4c021c.svg"
      }
    },
    "icon-icn-transfer.svg": {
      "name": "icon-icn-transfer",
      "hashedName": "icon-icn-transfer.f11a09b9faf3",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-icn-transfer.svg",
        "hashedPath": "icons/suffixed/icon-icn-transfer.f11a09b9faf3.svg"
      }
    },
    "icon-info.svg": {
      "name": "icon-info",
      "hashedName": "icon-info.086b2f2efccc",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-info.svg",
        "hashedPath": "icons/suffixed/icon-info.086b2f2efccc.svg"
      }
    },
    "icon-linked-carrier-success.svg": {
      "name": "icon-linked-carrier-success",
      "hashedName": "icon-linked-carrier-success.362ebc1d1281",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-linked-carrier-success.svg",
        "hashedPath": "icons/suffixed/icon-linked-carrier-success.362ebc1d1281.svg"
      }
    },
    "icon-linked.svg": {
      "name": "icon-linked",
      "hashedName": "icon-linked.3b39fe1a502e",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-linked.svg",
        "hashedPath": "icons/suffixed/icon-linked.3b39fe1a502e.svg"
      }
    },
    "icon-loader-spinner.svg": {
      "name": "icon-loader-spinner",
      "hashedName": "icon-loader-spinner.f328118b3df7",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-loader-spinner.svg",
        "hashedPath": "icons/suffixed/icon-loader-spinner.f328118b3df7.svg"
      }
    },
    "icon-logout.svg": {
      "name": "icon-logout",
      "hashedName": "icon-logout.5dbde91f34b6",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-logout.svg",
        "hashedPath": "icons/suffixed/icon-logout.5dbde91f34b6.svg"
      }
    },
    "icon-maintainence.svg": {
      "name": "icon-maintainence",
      "hashedName": "icon-maintainence.f38577178d7a",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-maintainence.svg",
        "hashedPath": "icons/suffixed/icon-maintainence.f38577178d7a.svg"
      }
    },
    "icon-minimum-transfer.svg": {
      "name": "icon-minimum-transfer",
      "hashedName": "icon-minimum-transfer.65a920bc16ea",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-minimum-transfer.svg",
        "hashedPath": "icons/suffixed/icon-minimum-transfer.65a920bc16ea.svg"
      }
    },
    "icon-minimum.svg": {
      "name": "icon-minimum",
      "hashedName": "icon-minimum.65a920bc16ea",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-minimum.svg",
        "hashedPath": "icons/suffixed/icon-minimum.65a920bc16ea.svg"
      }
    },
    "icon-minus.svg": {
      "name": "icon-minus",
      "hashedName": "icon-minus.293b8653241b",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-minus.svg",
        "hashedPath": "icons/suffixed/icon-minus.293b8653241b.svg"
      }
    },
    "icon-new-window.svg": {
      "name": "icon-new-window",
      "hashedName": "icon-new-window.8ca3b8ebad65",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-new-window.svg",
        "hashedPath": "icons/suffixed/icon-new-window.8ca3b8ebad65.svg"
      }
    },
    "icon-not-found.svg": {
      "name": "icon-not-found",
      "hashedName": "icon-not-found.c0bb9c4ce2a2",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-not-found.svg",
        "hashedPath": "icons/suffixed/icon-not-found.c0bb9c4ce2a2.svg"
      }
    },
    "icon-pagination-right.svg": {
      "name": "icon-pagination-right",
      "hashedName": "icon-pagination-right.018bcddd97de",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-pagination-right.svg",
        "hashedPath": "icons/suffixed/icon-pagination-right.018bcddd97de.svg"
      }
    },
    "icon-pending.svg": {
      "name": "icon-pending",
      "hashedName": "icon-pending.964ed40801ab",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-pending.svg",
        "hashedPath": "icons/suffixed/icon-pending.964ed40801ab.svg"
      }
    },
    "icon-plus.svg": {
      "name": "icon-plus",
      "hashedName": "icon-plus.80bbb120aa57",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-plus.svg",
        "hashedPath": "icons/suffixed/icon-plus.80bbb120aa57.svg"
      }
    },
    "icon-progress.svg": {
      "name": "icon-progress",
      "hashedName": "icon-progress.964ed40801ab",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-progress.svg",
        "hashedPath": "icons/suffixed/icon-progress.964ed40801ab.svg"
      }
    },
    "icon-read-more.svg": {
      "name": "icon-read-more",
      "hashedName": "icon-read-more.dc7211d83e1c",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-read-more.svg",
        "hashedPath": "icons/suffixed/icon-read-more.dc7211d83e1c.svg"
      }
    },
    "icon-search.svg": {
      "name": "icon-search",
      "hashedName": "icon-search.af2be8299a14",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-search.svg",
        "hashedPath": "icons/suffixed/icon-search.af2be8299a14.svg"
      }
    },
    "icon-session-expired.svg": {
      "name": "icon-session-expired",
      "hashedName": "icon-session-expired.c5b2bdde0199",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-session-expired.svg",
        "hashedPath": "icons/suffixed/icon-session-expired.c5b2bdde0199.svg"
      }
    },
    "icon-success.svg": {
      "name": "icon-success",
      "hashedName": "icon-success.ba8b0f1137c6",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-success.svg",
        "hashedPath": "icons/suffixed/icon-success.ba8b0f1137c6.svg"
      }
    },
    "icon-tc.svg": {
      "name": "icon-tc",
      "hashedName": "icon-tc.5af7b8384e90",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-tc.svg",
        "hashedPath": "icons/suffixed/icon-tc.5af7b8384e90.svg"
      }
    },
    "icon-time.svg": {
      "name": "icon-time",
      "hashedName": "icon-time.48c5d1103d5d",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-time.svg",
        "hashedPath": "icons/suffixed/icon-time.48c5d1103d5d.svg"
      }
    },
    "icon-transfer.svg": {
      "name": "icon-transfer",
      "hashedName": "icon-transfer.16afd09d99c8",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-transfer.svg",
        "hashedPath": "icons/suffixed/icon-transfer.16afd09d99c8.svg"
      }
    },
    "icon-unexpected-error.svg": {
      "name": "icon-unexpected-error",
      "hashedName": "icon-unexpected-error.994795b63437",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-unexpected-error.svg",
        "hashedPath": "icons/suffixed/icon-unexpected-error.994795b63437.svg"
      }
    },
    "icon-warning.svg": {
      "name": "icon-warning",
      "hashedName": "icon-warning.6f6456bba78c",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-warning.svg",
        "hashedPath": "icons/suffixed/icon-warning.6f6456bba78c.svg"
      }
    },
    "icon-x-sorry.svg": {
      "name": "icon-x-sorry",
      "hashedName": "icon-x-sorry.994795b63437",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-x-sorry.svg",
        "hashedPath": "icons/suffixed/icon-x-sorry.994795b63437.svg"
      }
    }
  },
  "images": {
    "GC-kv-desktop.jpg": {
      "name": "GC-kv-desktop",
      "hashedName": "GC-kv-desktop.ffe4934dd446",
      "extension": "jpg",
      "path": {
        "originalPath": "images/GC-kv-desktop.jpg",
        "hashedPath": "images/suffixed/GC-kv-desktop.ffe4934dd446.jpg"
      }
    },
    "GC-kv-mobile.jpg": {
      "name": "GC-kv-mobile",
      "hashedName": "GC-kv-mobile.710b1a43cc88",
      "extension": "jpg",
      "path": {
        "originalPath": "images/GC-kv-mobile.jpg",
        "hashedPath": "images/suffixed/GC-kv-mobile.710b1a43cc88.jpg"
      }
    },
    "RC.jpg": {
      "name": "RC",
      "hashedName": "RC.10fb11e350b3",
      "extension": "jpg",
      "path": {
        "originalPath": "images/RC.jpg",
        "hashedPath": "images/suffixed/RC.10fb11e350b3.jpg"
      }
    },
    "TC-kv-desktop.jpg": {
      "name": "TC-kv-desktop",
      "hashedName": "TC-kv-desktop.abfd0744f984",
      "extension": "jpg",
      "path": {
        "originalPath": "images/TC-kv-desktop.jpg",
        "hashedPath": "images/suffixed/TC-kv-desktop.abfd0744f984.jpg"
      }
    },
    "TC-kv-mobile.jpg": {
      "name": "TC-kv-mobile",
      "hashedName": "TC-kv-mobile.de8b5e1e68a5",
      "extension": "jpg",
      "path": {
        "originalPath": "images/TC-kv-mobile.jpg",
        "hashedPath": "images/suffixed/TC-kv-mobile.de8b5e1e68a5.jpg"
      }
    },
    "TC_ProductMasterHead_Desktop.avif": {
      "name": "TC_ProductMasterHead_Desktop",
      "hashedName": "TC_ProductMasterHead_Desktop.fb867c6c4147",
      "extension": "avif",
      "path": {
        "originalPath": "images/TC_ProductMasterHead_Desktop.avif",
        "hashedPath": "images/suffixed/TC_ProductMasterHead_Desktop.fb867c6c4147.avif"
      }
    },
    "TC_ProductMasterHead_Desktop.jpg": {
      "name": "TC_ProductMasterHead_Desktop",
      "hashedName": "TC_ProductMasterHead_Desktop.09052617b3bc",
      "extension": "jpg",
      "path": {
        "originalPath": "images/TC_ProductMasterHead_Desktop.jpg",
        "hashedPath": "images/suffixed/TC_ProductMasterHead_Desktop.09052617b3bc.jpg"
      }
    },
    "TC_ProductMasterHead_Desktop.webp": {
      "name": "TC_ProductMasterHead_Desktop",
      "hashedName": "TC_ProductMasterHead_Desktop.291cdfd5866f",
      "extension": "webp",
      "path": {
        "originalPath": "images/TC_ProductMasterHead_Desktop.webp",
        "hashedPath": "images/suffixed/TC_ProductMasterHead_Desktop.291cdfd5866f.webp"
      }
    },
    "TC_ProductMasterHead_Mobile.avif": {
      "name": "TC_ProductMasterHead_Mobile",
      "hashedName": "TC_ProductMasterHead_Mobile.357b38a57415",
      "extension": "avif",
      "path": {
        "originalPath": "images/TC_ProductMasterHead_Mobile.avif",
        "hashedPath": "images/suffixed/TC_ProductMasterHead_Mobile.357b38a57415.avif"
      }
    },
    "TC_ProductMasterHead_Mobile.jpg": {
      "name": "TC_ProductMasterHead_Mobile",
      "hashedName": "TC_ProductMasterHead_Mobile.2060d87605a5",
      "extension": "jpg",
      "path": {
        "originalPath": "images/TC_ProductMasterHead_Mobile.jpg",
        "hashedPath": "images/suffixed/TC_ProductMasterHead_Mobile.2060d87605a5.jpg"
      }
    },
    "TC_ProductMasterHead_Mobile.webp": {
      "name": "TC_ProductMasterHead_Mobile",
      "hashedName": "TC_ProductMasterHead_Mobile.5776163b0694",
      "extension": "webp",
      "path": {
        "originalPath": "images/TC_ProductMasterHead_Mobile.webp",
        "hashedPath": "images/suffixed/TC_ProductMasterHead_Mobile.5776163b0694.webp"
      }
    },
    "arrow-l-L.svg": {
      "name": "arrow-l-L",
      "hashedName": "arrow-l-L.e517d58b54d1",
      "extension": "svg",
      "path": {
        "originalPath": "images/arrow-l-L.svg",
        "hashedPath": "images/suffixed/arrow-l-L.e517d58b54d1.svg"
      }
    },
    "arrow-s-D.svg": {
      "name": "arrow-s-D",
      "hashedName": "arrow-s-D.015de3b2aedd",
      "extension": "svg",
      "path": {
        "originalPath": "images/arrow-s-D.svg",
        "hashedPath": "images/suffixed/arrow-s-D.015de3b2aedd.svg"
      }
    },
    "dark-logo.png": {
      "name": "dark-logo",
      "hashedName": "dark-logo.c36f0b7477a2",
      "extension": "png",
      "path": {
        "originalPath": "images/branding/dark-logo.png",
        "hashedPath": "images/branding/suffixed/dark-logo.c36f0b7477a2.png"
      }
    },
    "logo-ascendawhite.svg": {
      "name": "logo-ascendawhite",
      "hashedName": "logo-ascendawhite.62ca0b4be923",
      "extension": "svg",
      "path": {
        "originalPath": "images/branding/logo-ascendawhite.svg",
        "hashedPath": "images/branding/suffixed/logo-ascendawhite.62ca0b4be923.svg"
      }
    },
    "logo-star_alliance.svg": {
      "name": "logo-star_alliance",
      "hashedName": "logo-star_alliance.1eca67a60ca3",
      "extension": "svg",
      "path": {
        "originalPath": "images/branding/logo-star_alliance.svg",
        "hashedPath": "images/branding/suffixed/logo-star_alliance.1eca67a60ca3.svg"
      }
    },
    "select-carrier-mobile.avif": {
      "name": "select-carrier-mobile",
      "hashedName": "select-carrier-mobile.dedfd9f38ed0",
      "extension": "avif",
      "path": {
        "originalPath": "images/branding/select-carrier-mobile.avif",
        "hashedPath": "images/branding/suffixed/select-carrier-mobile.dedfd9f38ed0.avif"
      }
    },
    "select-carrier-mobile.jpg": {
      "name": "select-carrier-mobile",
      "hashedName": "select-carrier-mobile.15de72a0773e",
      "extension": "jpg",
      "path": {
        "originalPath": "images/branding/select-carrier-mobile.jpg",
        "hashedPath": "images/branding/suffixed/select-carrier-mobile.15de72a0773e.jpg"
      }
    },
    "select-carrier-mobile.webp": {
      "name": "select-carrier-mobile",
      "hashedName": "select-carrier-mobile.f86b24279da8",
      "extension": "webp",
      "path": {
        "originalPath": "images/branding/select-carrier-mobile.webp",
        "hashedPath": "images/branding/suffixed/select-carrier-mobile.f86b24279da8.webp"
      }
    },
    "select-carrier.avif": {
      "name": "select-carrier",
      "hashedName": "select-carrier.284885cadc88",
      "extension": "avif",
      "path": {
        "originalPath": "images/branding/select-carrier.avif",
        "hashedPath": "images/branding/suffixed/select-carrier.284885cadc88.avif"
      }
    },
    "select-carrier.jpg": {
      "name": "select-carrier",
      "hashedName": "select-carrier.eba898a0abb4",
      "extension": "jpg",
      "path": {
        "originalPath": "images/branding/select-carrier.jpg",
        "hashedPath": "images/branding/suffixed/select-carrier.eba898a0abb4.jpg"
      }
    },
    "select-carrier.webp": {
      "name": "select-carrier",
      "hashedName": "select-carrier.ca2e95299448",
      "extension": "webp",
      "path": {
        "originalPath": "images/branding/select-carrier.webp",
        "hashedPath": "images/branding/suffixed/select-carrier.ca2e95299448.webp"
      }
    },
    "empty-bonus-offer.png": {
      "name": "empty-bonus-offer",
      "hashedName": "empty-bonus-offer.1457bcca6293",
      "extension": "png",
      "path": {
        "originalPath": "images/empty-bonus-offer.png",
        "hashedPath": "images/suffixed/empty-bonus-offer.1457bcca6293.png"
      }
    },
    "equal-icon-grey.svg": {
      "name": "equal-icon-grey",
      "hashedName": "equal-icon-grey.aa40bb307cab",
      "extension": "svg",
      "path": {
        "originalPath": "images/equal-icon-grey.svg",
        "hashedPath": "images/suffixed/equal-icon-grey.aa40bb307cab.svg"
      }
    },
    "flags-25-standard.png": {
      "name": "flags-25-standard",
      "hashedName": "flags-25-standard.8666ae55b0c8",
      "extension": "png",
      "path": {
        "originalPath": "images/flags/flags-25-standard.png",
        "hashedPath": "images/flags/suffixed/flags-25-standard.8666ae55b0c8.png"
      }
    },
    "rd-banner-dekstop.jpg": {
      "name": "rd-banner-dekstop",
      "hashedName": "rd-banner-dekstop.9939d9a4e5c6",
      "extension": "jpg",
      "path": {
        "originalPath": "images/homepage/rd-banner-dekstop.jpg",
        "hashedPath": "images/homepage/suffixed/rd-banner-dekstop.9939d9a4e5c6.jpg"
      }
    },
    "rd-banner-mobile.jpg": {
      "name": "rd-banner-mobile",
      "hashedName": "rd-banner-mobile.40f674ca6506",
      "extension": "jpg",
      "path": {
        "originalPath": "images/homepage/rd-banner-mobile.jpg",
        "hashedPath": "images/homepage/suffixed/rd-banner-mobile.40f674ca6506.jpg"
      }
    },
    "icn-close-dark.svg": {
      "name": "icn-close-dark",
      "hashedName": "icn-close-dark.8be668b16a6d",
      "extension": "svg",
      "path": {
        "originalPath": "images/icn-close-dark.svg",
        "hashedPath": "images/suffixed/icn-close-dark.8be668b16a6d.svg"
      }
    },
    "icn-emptytransaction.svg": {
      "name": "icn-emptytransaction",
      "hashedName": "icn-emptytransaction.958c507ddf2d",
      "extension": "svg",
      "path": {
        "originalPath": "images/icn-emptytransaction.svg",
        "hashedPath": "images/suffixed/icn-emptytransaction.958c507ddf2d.svg"
      }
    },
    "icn-noresultsgc.svg": {
      "name": "icn-noresultsgc",
      "hashedName": "icn-noresultsgc.4f4cc9567910",
      "extension": "svg",
      "path": {
        "originalPath": "images/icn-noresultsgc.svg",
        "hashedPath": "images/suffixed/icn-noresultsgc.4f4cc9567910.svg"
      }
    },
    "icn-noresultstcrc.svg": {
      "name": "icn-noresultstcrc",
      "hashedName": "icn-noresultstcrc.5af7b8384e90",
      "extension": "svg",
      "path": {
        "originalPath": "images/icn-noresultstcrc.svg",
        "hashedPath": "images/suffixed/icn-noresultstcrc.5af7b8384e90.svg"
      }
    },
    "placeholder.png": {
      "name": "placeholder",
      "hashedName": "placeholder.980edc01a77f",
      "extension": "png",
      "path": {
        "originalPath": "images/placeholder.png",
        "hashedPath": "images/suffixed/placeholder.980edc01a77f.png"
      }
    },
    "benefit_airport_lounge_access.png": {
      "name": "benefit_airport_lounge_access",
      "hashedName": "benefit_airport_lounge_access.6dbdace0e436",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/benefit_airport_lounge_access.png",
        "hashedPath": "images/rd/suffixed/benefit_airport_lounge_access.6dbdace0e436.png"
      }
    },
    "benefit_extra_baggage_allowance.png": {
      "name": "benefit_extra_baggage_allowance",
      "hashedName": "benefit_extra_baggage_allowance.c637cd83d000",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/benefit_extra_baggage_allowance.png",
        "hashedPath": "images/rd/suffixed/benefit_extra_baggage_allowance.c637cd83d000.png"
      }
    },
    "benefit_gold_track.png": {
      "name": "benefit_gold_track",
      "hashedName": "benefit_gold_track.fb1175c167c6",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/benefit_gold_track.png",
        "hashedPath": "images/rd/suffixed/benefit_gold_track.fb1175c167c6.png"
      }
    },
    "benefit_priority_airport_check-in.png": {
      "name": "benefit_priority_airport_check-in",
      "hashedName": "benefit_priority_airport_check-in.4c2ea1bee58c",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/benefit_priority_airport_check-in.png",
        "hashedPath": "images/rd/suffixed/benefit_priority_airport_check-in.4c2ea1bee58c.png"
      }
    },
    "benefit_priority_airport_stand-by.png": {
      "name": "benefit_priority_airport_stand-by",
      "hashedName": "benefit_priority_airport_stand-by.3e19304aa939",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/benefit_priority_airport_stand-by.png",
        "hashedPath": "images/rd/suffixed/benefit_priority_airport_stand-by.3e19304aa939.png"
      }
    },
    "benefit_priority_baggae_handling.png": {
      "name": "benefit_priority_baggae_handling",
      "hashedName": "benefit_priority_baggae_handling.bda7ef6acbb8",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/benefit_priority_baggae_handling.png",
        "hashedPath": "images/rd/suffixed/benefit_priority_baggae_handling.bda7ef6acbb8.png"
      }
    },
    "benefit_priority_boarding.png": {
      "name": "benefit_priority_boarding",
      "hashedName": "benefit_priority_boarding.cdea9501b6be",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/benefit_priority_boarding.png",
        "hashedPath": "images/rd/suffixed/benefit_priority_boarding.cdea9501b6be.png"
      }
    },
    "benefit_priority_reservations_waitlist.png": {
      "name": "benefit_priority_reservations_waitlist",
      "hashedName": "benefit_priority_reservations_waitlist.9605d1f3d2c5",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/benefit_priority_reservations_waitlist.png",
        "hashedPath": "images/rd/suffixed/benefit_priority_reservations_waitlist.9605d1f3d2c5.png"
      }
    },
    "brand_air_ana.png": {
      "name": "brand_air_ana",
      "hashedName": "brand_air_ana.6df5d64c70f9",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_air_ana.png",
        "hashedPath": "images/rd/suffixed/brand_air_ana.6df5d64c70f9.png"
      }
    },
    "brand_air_canada.png": {
      "name": "brand_air_canada",
      "hashedName": "brand_air_canada.9787715a7b02",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_air_canada.png",
        "hashedPath": "images/rd/suffixed/brand_air_canada.9787715a7b02.png"
      }
    },
    "brand_air_india.png": {
      "name": "brand_air_india",
      "hashedName": "brand_air_india.7f32a1f19e01",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_air_india.png",
        "hashedPath": "images/rd/suffixed/brand_air_india.7f32a1f19e01.png"
      }
    },
    "brand_air_new_zealand.png": {
      "name": "brand_air_new_zealand",
      "hashedName": "brand_air_new_zealand.6407ec3ba6fc",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_air_new_zealand.png",
        "hashedPath": "images/rd/suffixed/brand_air_new_zealand.6407ec3ba6fc.png"
      }
    },
    "brand_eva_air.png": {
      "name": "brand_eva_air",
      "hashedName": "brand_eva_air.0c9906dcd97f",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_eva_air.png",
        "hashedPath": "images/rd/suffixed/brand_eva_air.0c9906dcd97f.png"
      }
    },
    "brand_singapore_airlines.png": {
      "name": "brand_singapore_airlines",
      "hashedName": "brand_singapore_airlines.84c1884ed430",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_singapore_airlines.png",
        "hashedPath": "images/rd/suffixed/brand_singapore_airlines.84c1884ed430.png"
      }
    },
    "brand_south_african_airway.png": {
      "name": "brand_south_african_airway",
      "hashedName": "brand_south_african_airway.21aca724b545",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_south_african_airway.png",
        "hashedPath": "images/rd/suffixed/brand_south_african_airway.21aca724b545.png"
      }
    },
    "brand_thai_airways.png": {
      "name": "brand_thai_airways",
      "hashedName": "brand_thai_airways.aede7f81308b",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_thai_airways.png",
        "hashedPath": "images/rd/suffixed/brand_thai_airways.aede7f81308b.png"
      }
    },
    "brand_united_airlines.png": {
      "name": "brand_united_airlines",
      "hashedName": "brand_united_airlines.b9abf6635e49",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/brand_united_airlines.png",
        "hashedPath": "images/rd/suffixed/brand_united_airlines.b9abf6635e49.png"
      }
    },
    "earning points.jpg": {
      "name": "earning points",
      "hashedName": "earning points.104e6363481c",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd/earning points.jpg",
        "hashedPath": "images/rd/suffixed/earning points.104e6363481c.jpg"
      }
    },
    "auth-failed.svg": {
      "name": "auth-failed",
      "hashedName": "auth-failed.7c2dd451a923",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/auth-failed.svg",
        "hashedPath": "images/rd/errors/suffixed/auth-failed.7c2dd451a923.svg"
      }
    },
    "id-error.svg": {
      "name": "id-error",
      "hashedName": "id-error.e9ece0299c93",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/id-error.svg",
        "hashedPath": "images/rd/errors/suffixed/id-error.e9ece0299c93.svg"
      }
    },
    "otp-error.svg": {
      "name": "otp-error",
      "hashedName": "otp-error.8ed89961fd20",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/otp-error.svg",
        "hashedPath": "images/rd/errors/suffixed/otp-error.8ed89961fd20.svg"
      }
    },
    "page-error.png": {
      "name": "page-error",
      "hashedName": "page-error.55c275100307",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/errors/page-error.png",
        "hashedPath": "images/rd/errors/suffixed/page-error.55c275100307.png"
      }
    },
    "payment-failed.svg": {
      "name": "payment-failed",
      "hashedName": "payment-failed.30d8d5985c71",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/payment-failed.svg",
        "hashedPath": "images/rd/errors/suffixed/payment-failed.30d8d5985c71.svg"
      }
    },
    "supplier-error.svg": {
      "name": "supplier-error",
      "hashedName": "supplier-error.0ca2b0870918",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/supplier-error.svg",
        "hashedPath": "images/rd/errors/suffixed/supplier-error.0ca2b0870918.svg"
      }
    },
    "timeout.svg": {
      "name": "timeout",
      "hashedName": "timeout.d2b8f18064e0",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/timeout.svg",
        "hashedPath": "images/rd/errors/suffixed/timeout.d2b8f18064e0.svg"
      }
    },
    "unexpected-error.svg": {
      "name": "unexpected-error",
      "hashedName": "unexpected-error.bfb2991840dc",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/unexpected-error.svg",
        "hashedPath": "images/rd/errors/suffixed/unexpected-error.bfb2991840dc.svg"
      }
    },
    "processing-loading.svg": {
      "name": "processing-loading",
      "hashedName": "processing-loading.48cc33216db4",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/processing-loading.svg",
        "hashedPath": "images/rd/suffixed/processing-loading.48cc33216db4.svg"
      }
    },
    "rd-earn-points-mobile.jpeg": {
      "name": "rd-earn-points-mobile",
      "hashedName": "rd-earn-points-mobile.f378498687dd",
      "extension": "jpeg",
      "path": {
        "originalPath": "images/rd/rd-earn-points-mobile.jpeg",
        "hashedPath": "images/rd/suffixed/rd-earn-points-mobile.f378498687dd.jpeg"
      }
    },
    "rd-earn-points.jpeg": {
      "name": "rd-earn-points",
      "hashedName": "rd-earn-points.277c146c31c9",
      "extension": "jpeg",
      "path": {
        "originalPath": "images/rd/rd-earn-points.jpeg",
        "hashedPath": "images/rd/suffixed/rd-earn-points.277c146c31c9.jpeg"
      }
    },
    "rd-homepage-banner-desktop.avif": {
      "name": "rd-homepage-banner-desktop",
      "hashedName": "rd-homepage-banner-desktop.216c0803c8dc",
      "extension": "avif",
      "path": {
        "originalPath": "images/rd/rd-homepage-banner-desktop.avif",
        "hashedPath": "images/rd/suffixed/rd-homepage-banner-desktop.216c0803c8dc.avif"
      }
    },
    "rd-homepage-banner-desktop.jpeg": {
      "name": "rd-homepage-banner-desktop",
      "hashedName": "rd-homepage-banner-desktop.5923dd4a190e",
      "extension": "jpeg",
      "path": {
        "originalPath": "images/rd/rd-homepage-banner-desktop.jpeg",
        "hashedPath": "images/rd/suffixed/rd-homepage-banner-desktop.5923dd4a190e.jpeg"
      }
    },
    "rd-homepage-banner-desktop.jpg": {
      "name": "rd-homepage-banner-desktop",
      "hashedName": "rd-homepage-banner-desktop.9f74ffd2951f",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd/rd-homepage-banner-desktop.jpg",
        "hashedPath": "images/rd/suffixed/rd-homepage-banner-desktop.9f74ffd2951f.jpg"
      }
    },
    "rd-homepage-banner-desktop.webp": {
      "name": "rd-homepage-banner-desktop",
      "hashedName": "rd-homepage-banner-desktop.79627e66609b",
      "extension": "webp",
      "path": {
        "originalPath": "images/rd/rd-homepage-banner-desktop.webp",
        "hashedPath": "images/rd/suffixed/rd-homepage-banner-desktop.79627e66609b.webp"
      }
    },
    "rd-homepage-banner-mobile.avif": {
      "name": "rd-homepage-banner-mobile",
      "hashedName": "rd-homepage-banner-mobile.0a957ea94bae",
      "extension": "avif",
      "path": {
        "originalPath": "images/rd/rd-homepage-banner-mobile.avif",
        "hashedPath": "images/rd/suffixed/rd-homepage-banner-mobile.0a957ea94bae.avif"
      }
    },
    "rd-homepage-banner-mobile.jpeg": {
      "name": "rd-homepage-banner-mobile",
      "hashedName": "rd-homepage-banner-mobile.570e5006001f",
      "extension": "jpeg",
      "path": {
        "originalPath": "images/rd/rd-homepage-banner-mobile.jpeg",
        "hashedPath": "images/rd/suffixed/rd-homepage-banner-mobile.570e5006001f.jpeg"
      }
    },
    "rd-homepage-banner-mobile.jpg": {
      "name": "rd-homepage-banner-mobile",
      "hashedName": "rd-homepage-banner-mobile.c27ea4011604",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd/rd-homepage-banner-mobile.jpg",
        "hashedPath": "images/rd/suffixed/rd-homepage-banner-mobile.c27ea4011604.jpg"
      }
    },
    "rd-homepage-banner-mobile.webp": {
      "name": "rd-homepage-banner-mobile",
      "hashedName": "rd-homepage-banner-mobile.b09be9898859",
      "extension": "webp",
      "path": {
        "originalPath": "images/rd/rd-homepage-banner-mobile.webp",
        "hashedPath": "images/rd/suffixed/rd-homepage-banner-mobile.b09be9898859.webp"
      }
    },
    "rd-use-points-mobile.jpeg": {
      "name": "rd-use-points-mobile",
      "hashedName": "rd-use-points-mobile.496bc0ef09e6",
      "extension": "jpeg",
      "path": {
        "originalPath": "images/rd/rd-use-points-mobile.jpeg",
        "hashedPath": "images/rd/suffixed/rd-use-points-mobile.496bc0ef09e6.jpeg"
      }
    },
    "rd-use-points.jpeg": {
      "name": "rd-use-points",
      "hashedName": "rd-use-points.8784c288a5b8",
      "extension": "jpeg",
      "path": {
        "originalPath": "images/rd/rd-use-points.jpeg",
        "hashedPath": "images/rd/suffixed/rd-use-points.8784c288a5b8.jpeg"
      }
    },
    "rd-arrow-left.png": {
      "name": "rd-arrow-left",
      "hashedName": "rd-arrow-left.4440685632e2",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-arrow-left.png",
        "hashedPath": "images/suffixed/rd-arrow-left.4440685632e2.png"
      }
    },
    "rd-arrow-right.png": {
      "name": "rd-arrow-right",
      "hashedName": "rd-arrow-right.8c5ea704b133",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-arrow-right.png",
        "hashedPath": "images/suffixed/rd-arrow-right.8c5ea704b133.png"
      }
    },
    "rd-back-arrow.png": {
      "name": "rd-back-arrow",
      "hashedName": "rd-back-arrow.513594f85017",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-back-arrow.png",
        "hashedPath": "images/suffixed/rd-back-arrow.513594f85017.png"
      }
    },
    "rd-empty-expire-points.png": {
      "name": "rd-empty-expire-points",
      "hashedName": "rd-empty-expire-points.662a9be89752",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-empty-expire-points.png",
        "hashedPath": "images/suffixed/rd-empty-expire-points.662a9be89752.png"
      }
    },
    "rd-equal-icon.svg": {
      "name": "rd-equal-icon",
      "hashedName": "rd-equal-icon.aa40bb307cab",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd-equal-icon.svg",
        "hashedPath": "images/suffixed/rd-equal-icon.aa40bb307cab.svg"
      }
    },
    "rd-pagination-active.png": {
      "name": "rd-pagination-active",
      "hashedName": "rd-pagination-active.67ee464fd31b",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-pagination-active.png",
        "hashedPath": "images/suffixed/rd-pagination-active.67ee464fd31b.png"
      }
    },
    "rd-pagination-inactive.png": {
      "name": "rd-pagination-inactive",
      "hashedName": "rd-pagination-inactive.489bc9c73cda",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-pagination-inactive.png",
        "hashedPath": "images/suffixed/rd-pagination-inactive.489bc9c73cda.png"
      }
    },
    "rd-photos-booking-priority.jpg": {
      "name": "rd-photos-booking-priority",
      "hashedName": "rd-photos-booking-priority.92c0132ef08c",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-booking-priority.jpg",
        "hashedPath": "images/suffixed/rd-photos-booking-priority.92c0132ef08c.jpg"
      }
    },
    "rd-photos-box-office-access.jpg": {
      "name": "rd-photos-box-office-access",
      "hashedName": "rd-photos-box-office-access.3bcb0022c25a",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-box-office-access.jpg",
        "hashedPath": "images/suffixed/rd-photos-box-office-access.3bcb0022c25a.jpg"
      }
    },
    "rd-photos-gourmet.jpg": {
      "name": "rd-photos-gourmet",
      "hashedName": "rd-photos-gourmet.1f7208e27856",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-gourmet.jpg",
        "hashedPath": "images/suffixed/rd-photos-gourmet.1f7208e27856.jpg"
      }
    },
    "rd-photos-helicopter.jpg": {
      "name": "rd-photos-helicopter",
      "hashedName": "rd-photos-helicopter.3bcb0022c25a",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-helicopter.jpg",
        "hashedPath": "images/suffixed/rd-photos-helicopter.3bcb0022c25a.jpg"
      }
    },
    "rd-photos-opera.jpg": {
      "name": "rd-photos-opera",
      "hashedName": "rd-photos-opera.92c0132ef08c",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-opera.jpg",
        "hashedPath": "images/suffixed/rd-photos-opera.92c0132ef08c.jpg"
      }
    },
    "rd-points-transaction-icon.png": {
      "name": "rd-points-transaction-icon",
      "hashedName": "rd-points-transaction-icon.7c917cf624f4",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-points-transaction-icon.png",
        "hashedPath": "images/suffixed/rd-points-transaction-icon.7c917cf624f4.png"
      }
    },
    "rd-search-icon.png": {
      "name": "rd-search-icon",
      "hashedName": "rd-search-icon.7d04ca7daa59",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-search-icon.png",
        "hashedPath": "images/suffixed/rd-search-icon.7d04ca7daa59.png"
      }
    },
    "rd_banner.jpg": {
      "name": "rd_banner",
      "hashedName": "rd_banner.f2d60c362985",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd_banner.jpg",
        "hashedPath": "images/suffixed/rd_banner.f2d60c362985.jpg"
      }
    }
  },
  "i18n": {
    "en-GB.json": {
      "name": "en-GB",
      "hashedName": "en-GB.346505aca2b8",
      "extension": "json",
      "path": {
        "originalPath": "i18n/en-GB.json",
        "hashedPath": "i18n/suffixed/en-GB.346505aca2b8.json"
      }
    }
  }
} 

export type AssetMap = typeof assetMap